// 销售人员明细
<template>
  <div id="checkCard">
    <navbar />
    <!-- <v-header></v-header> -->
    <div class="checkCard">
      <div class="content">
        <!-- 销售人员明细查询条件 -->
        <div class="contentHeader">
          <el-row :gutter="10" style="font-weight:400;color:rgba(51,51,51,1);">
            <el-col :span="8">
              机构
              <el-cascader
                id='cascader-multi'
                v-model="mechanism"
                ref="cascader1"
                placeholder="请选择机构名称"
                :options="mechanismOptions"
                :props="{ checkStrictly: true }"
                clearable>
              </el-cascader>
            </el-col>
            <el-col :span="8">
              销售人员业务编码
              <el-input v-model="agentCode" placeholder="请输入业务编码" style="width:50%"></el-input>
            </el-col>
            <el-col :span="8">
              销售人员姓名
              <el-input v-model="agentName" placeholder="请输入姓名" style="width:50%"></el-input>
            </el-col>
          </el-row>
          <el-row :gutter="10" style="font-weight:400;color:rgba(51,51,51,1);">
            <el-col :span="8">
              客户证件到期日
              <el-date-picker v-model="cusTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-col>
            <el-col :span="8">
              证件更新时间
              <el-date-picker v-model="cardTime" style="width:74%" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8" :offset="8">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-button class="btnFront" @click="reset">重置</el-button>
                </el-col>
                <el-col :span="8">
                  <el-button class="btnFront" @click="search">查询</el-button>
                </el-col>
                <el-col :span="8">
                  <el-button class="btnBack" @click="exportTo">导出</el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
        <div class="contentBody">
          <el-table :data="tableData" border style="width: 100%" :header-cell-style="tableHeaderColor" :cell-style="tableCellStyle" >
            <el-table-column type="index" label="序号" width="80"></el-table-column>
            <el-table-column prop="orgStr" label="机构" ></el-table-column>
            <el-table-column prop="agentName" label="销售人员姓名" ></el-table-column>
            <el-table-column prop="agentCode" label="销售人员编码" ></el-table-column>
            <el-table-column prop="countExpired" label="过期客户数量" ></el-table-column>
            <el-table-column prop="countNoUpdate" label="未更新有效期客户数量" ></el-table-column>
          </el-table>
        </div>
        <div class="contentFooter">
          <el-pagination
            @current-change="handleCurrentChange"
            :page-size= "pagesize"
            :current-page="currentPage"
            layout="total, prev, pager, next"
            :total="count">
          </el-pagination>
        </div>
      </div>
      <v-footer></v-footer>
    </div>
  </div>
</template>
<script>
import vFooter from "@/layout/Footer.vue";
import vHeader from '@/layout/Header.vue'
import Navbar from "@/modules/Navbar";
import url from "@/modules/url.js";
import api from "@/modules/api.js";
import { Loading } from "element-ui";
export default {
  name: "checkCard",
  components: {
    vFooter,Navbar
  },
  data() {
    return {
      mechanismOptions: [],
      mechanism: [],
      agentCode: "",
      agentName: "",
      tableData: [],
      tableHeight: "100%",
      pagesize: 20,
      currentPage: 1,
      count: 0,
      loadingOpt: {
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      },
      cusTime:'',
      cardTime:''
    };
  },
  mounted() {
    this.getParticipants();
    this.getManagecomLst();
    this.$nextTick(() => {
      this.getTableHeight();
    });
    document.documentElement.scrollTop = document.body.scrollTop = 0;
  },
  methods: {
    getTableHeight() {
      this.tableHeight = document.querySelector(".contentBody").clientHeight*2;
    },
    getParticipants(a,str) {
      this.tableData = []
      this.count = 0
      let t2Code = ''
      let t3Code = ''
      let t4Code = ''
      let curNode = this.$refs['cascader1'].getCheckedNodes()[0]
      if(str != 'reset') {
        if(!!curNode && curNode.data.level == '4') {
          t4Code = curNode.data.value
          if(!!curNode.parent && curNode.parent.data.level == '3') {
            t3Code = curNode.parent.data.value
            if(!!curNode.parent.parent && curNode.parent.parent.data.level == '2') {
              t2Code = curNode.parent.parent.data.value
            }
          }
        } else if(!!curNode && curNode.data.level == '3') {
          t3Code = curNode.data.value
          if(!!curNode.parent && curNode.parent.data.level == '2') {
            t2Code = curNode.parent.data.value
          }
        } else if(!!curNode && curNode.data.level == '2') {
          t2Code = curNode.data.value
        }
      }
      let req = {
        t2Code: t2Code,
        t3Code: t3Code,
        t4Code: t4Code,
        agentCode: this.agentCode,
        agentName: this.agentName,
        offset: a || this.currentPage,
        limit: 20,
        expiryDateSatrt: this.cusTime != null && this.cusTime[0] ? this.cusTime[0] + ' 00:00:00' : '',
        expiryDateEnd: this.cusTime != null && this.cusTime[1] ? this.cusTime[1] + ' 23:59:59' : '',
        updateTimeStart: this.cardTime != null && this.cardTime[0] ? this.cardTime[0] + ' 00:00:00' : '',
        updateTimeEnd: this.cardTime != null && this.cardTime[1] ? this.cardTime[1] + ' 23:59:59' : '',
      }
      let loadingInstance = Loading.service(this.loadingOpt);
      api.post(url.querySalesStaffDetails, req, (res) => {
        this.$nextTick(() => {
          // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
        if (res.result.isSuccess) {
          this.count = res.data.size;
          this.tableData = res.data.list.map((item) => {
            item['orgStr'] = item.t2Name + (item.t2Name.indexOf(item.t3Name) > -1 ? '':item.t3Name) + item.t4Name
            return item
          })
          this.currentPage = a || 1
          // this.count = res.data.size;
        } else {
          if (res.result.errors.length > 0) {
            this.$message(
              res.result.errors[0].errorCode + res.result.errors[0].error
            );
          } else {
            this.$message(res.result.error);
          }
        }
      });
    },
    // 获取机构列表
    getManagecomLst() {
      let loadingInstance = Loading.service(this.loadingOpt);
      let msg = {
        platform: "PC",
        flag: true
      };
      api.post(url.getOrgList, msg, res => {
        this.$nextTick(() => {
          // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
        if (res.result.isSuccess === true) {
          console.log(res)
          let children = JSON.stringify(res.data)
            .trim()
            .replace(/"children":\[\],/g, "");
          this.mechanismOptions= JSON.parse(children);
          // this.mechanismOptionsT2= JSON.parse(JSON.stringify(this.mechanismOptions))
          // this.mechanismOptionsNew= JSON.parse(JSON.stringify(this.mechanismOptions))
          // this.mechanismOptionsT2.forEach(item=>{
          //   item.children.forEach(element=>{
          //     delete element.children
          //   })
          // })
        } else {
          if (res.result.errors.length > 0) {
            this.$message(
              res.result.errors[0].errorCode + res.result.errors[0].error
            );
          } else {
            this.$message(res.result.error);
          }
        }
      });
    },
    search() {
      this.currentPage = 1
      this.getParticipants();
    },
    reset() {
      this.mechanism = [];
      this.cusTime = this.cardTime = []
      this.agentCode = this.agentName = "";
      this.getParticipants('','reset')
    },
    exportTo() {
      let t2Code = ''
      let t3Code = ''
      let t4Code = ''
      let curNode = this.$refs['cascader1'].getCheckedNodes()[0]
      if(!!curNode && curNode.data.level == '4') {
        t4Code = curNode.data.value
        if(!!curNode.parent && curNode.parent.data.level == '3') {
          t3Code = curNode.parent.data.value
          if(!!curNode.parent.parent && curNode.parent.parent.data.level == '2') {
            t2Code = curNode.parent.parent.data.value
          }
        }
      } else if(!!curNode && curNode.data.level == '3') {
        t3Code = curNode.data.value
        if(!!curNode.parent && curNode.parent.data.level == '2') {
          t2Code = curNode.parent.data.value
        }
      } else if(!!curNode && curNode.data.level == '2') {
        t2Code = curNode.data.value
      }
      let req = {
        t2Code: t2Code,
        t3Code: t3Code,
        t4Code: t4Code,
        agentCode: this.agentCode,
        agentName: this.agentName,
        expiryDateSatrt: this.cusTime != null && this.cusTime[0] ? this.cusTime[0] + ' 00:00:00' : '',
        expiryDateEnd: this.cusTime != null && this.cusTime[1] ? this.cusTime[1] + ' 23:59:59' : '',
        updateTimeStart: this.cardTime != null && this.cardTime[0] ? this.cardTime[0] + ' 00:00:00' : '',
        updateTimeEnd: this.cardTime != null && this.cardTime[1] ? this.cardTime[1] + ' 23:59:59' : '',

      };
      let loadingInstance = Loading.service(this.loadingOpt);
      api.post(url.exportQuerySalesStaffDetails, req, (res) => {
        this.$nextTick(() => {
          // 以服务的方式调用的 Loading 需要异步关闭
          loadingInstance.close();
        });
        if (res.result.isSuccess === true) {
          let saveLink = document.createElement("a");
          saveLink.href = res.data;
          saveLink.download = "销售人员明细列表";
          saveLink.click();
        } else {
          if (res.result.errors.length > 0) {
            this.$message(
              res.result.errors[0].errorCode + res.result.errors[0].error
            );
          } else {
            this.$message(res.result.error);
          }
        }
      });
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "font-weight:bold;color:rgba(211,189,142,1);text-align:center;";
      }
    },
    tableCellStyle({ row, rowIndex }) {
      return "text-align:center;";
    },
    handleCurrentChange(val) {
      this.getParticipants(val);
      document.querySelectorAll(".el-table__body-wrapper")[0].scrollTop = 0;
      document.querySelectorAll(".el-table__body-wrapper")[0].scrollLeft = 0;
    },
    // 进入个人详情页面
    goSelfInfo(arg) {
      console.log("选中的每行数据",arg)
      this.$router.push({
        name:'checkCardDetail',
        params: arg
      })
    }
  },
};
</script>
<style scoped>
/* #checkCard {
  font-family: PingFang SC;
  height: 100%;
} */
.participant {
  background-color: #f5f6fa;
  padding: 0 25px;
  height: 100%;
}
.content {
  height: calc(100% - 40px);
  background: rgba(255, 255, 255, 1);
  border: 2px solid rgba(229, 229, 229, 1);
  margin-top: 14px;
}
.contentHeader {
  background: rgba(223, 223, 223, 0);
  border: 1px solid rgba(223, 223, 223, 1);
  margin: 20px 30px 10px;
  padding: 20px 30px;
}
.contentHeader .el-row:last-child {
  padding-bottom: 0px;
}
.el-input__inner {
  height: 35px;
}
.el-input,
.el-select,
.el-date-editor,
.el-cascader {
  width: 70%;
}
.el-row {
  padding-bottom: 20px;
}
.contentHeader .btnFront {
  background: rgba(25, 71, 147, 1);
  color: #fff;
}
.contentBody {
  padding: 0 30px;
  height: calc(100% - 280px);
}
.contentFooter {
  text-align: center;
  margin-top: 10px;
}
.recommender {
  letter-spacing: 5px;
}
.contentHeader .btnBack {
  background: rgba(210, 187, 139, 1);
  color: #fff;
  font-weight: bold;
}
.tipTitle {
  letter-spacing: 5px;
}
#cascader-multi {
  width: 82% !important;
  display: inline-block;
}
.contentBody /deep/ .el-table__cell{
  padding: 10px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/checkCard/list2.vue